import { Panel } from 'primereact/panel';
import { Filter } from 'lucide-react';
import { RadioButton } from 'primereact/radiobutton';

import { WIDGET_FILTER_TYPES } from '../constant/constant';

const WidgetTypeFilter = ({ action, widgetFormik }) => {
  const headerTemplate = () => {
    return (
      <div className="flex align-items-center gap-2 text-sm font-medium text-gray-700">
        <Filter className="text-primary text-sm w-1rem h-1rem" />
        <span className="text-sm font-bold text-gray-500">
          Widget Filter Type
        </span>
      </div>
    );
  };
  return (
    <Panel header={headerTemplate} className="w-full">
      <div className="flex flex-wrap gap-3">
        {Object.keys(WIDGET_FILTER_TYPES).map((key, index) => (
          <div className="flex align-items-center" key={key}>
            <RadioButton
              inputId={key}
              name={key}
              value={key}
              onChange={event => {
                widgetFormik.setFieldValue(
                  'widget_filter_type',
                  event?.value || ''
                );
              }}
              checked={key === widgetFormik.values.widget_filter_type}
              disabled={
                action === 'view' ||
                (widgetFormik.values.is_third_party === 1 && index !== 0)
              }
            />
            <label htmlFor={key} className="ml-2">
              {WIDGET_FILTER_TYPES[key]}
            </label>
          </div>
        ))}
      </div>
    </Panel>
  );
};

export default WidgetTypeFilter;
